var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 1.25C12.4141 1.25 12.7498 1.58579 12.7498 2H17.1714C17.7019 2 18.2106 2.21071 18.5856 2.58579L21.2927 5.29289C21.6833 5.68342 21.6833 6.31658 21.2927 6.70711L18.5856 9.41421C18.2106 9.78929 17.7019 10 17.1714 10H12.7498V11H17.9998C19.1044 11 19.9998 11.8954 19.9998 13V17C19.9998 18.1046 19.1044 19 17.9998 19H12.7498V22C12.7498 22.4142 12.4141 22.75 11.9998 22.75C11.5856 22.75 11.2498 22.4142 11.2498 22V19H6.82828C6.29784 19 5.78914 18.7893 5.41406 18.4142L2.70696 15.7071C2.31643 15.3166 2.31643 14.6834 2.70696 14.2929L5.41406 11.5858C5.78914 11.2107 6.29784 11 6.82828 11H11.2498V10H5.99985C4.89528 10 3.99985 9.10457 3.99985 8V4C3.99985 2.89543 4.89528 2 5.99985 2H11.2498C11.2498 1.58579 11.5856 1.25 11.9998 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionAlt);
export default __webpack_public_path__ + "static/media/direction-alt.a58820cd15369f2127d3191f02a0294d.svg";
export { ForwardRef as ReactComponent };